import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
    //NOTE: Do not pass the keyword "type" as an argument, as it will override the action type name.

    logIn: ['email', 'password', 'history'],
    logInSuccess: [],
    logInFailed: ['errorMessage'],

    signUp: ['email', 'password', 'history'],
    signUpSuccess: [],
    signUpFailed: ['errorMessage'],

    confirmSignUp: ['confirmationCode', 'email', 'password', 'history'],
    confirmSignUpSuccess: [],
    confirmSignUpFailed: ['errorMessage'],

    resendCode: ['email'],
    resendCodeSuccess: [],
    resendCodeFailure: [],
})

export const AuthTypes = Types

const INITIAL_STATE = {
    loadingLogin: false,
    logInFailedErrorMessage: null,
    loadingSignUp: false,
    signUpFailedErrorMessage: null,
    loadingConfirmSignUp: false,
    confirmSignUpErrorMessage: null,
    loadingResendCode: false,
    resendCodeSucceeded: 0,
    resendCodeFailed: 0,
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.LOG_IN]: state => ({
        ...state,
        loadingLogin: true,
        logInFailedErrorMessage: null,
    }),
    [Types.LOG_IN_SUCCESS]: state => ({ ...state, loadingLogin: false }),
    [Types.LOG_IN_FAILED]: (state, { errorMessage }) => ({ ...state, loadingLogin: false, logInFailedErrorMessage: errorMessage }),

    [Types.SIGN_UP]: state => ({ ...state, loadingSignUp: true, signUpFailedErrorMessage: null }),
    [Types.SIGN_UP_SUCCESS]: state => ({ ...state, loadingSignUp: false }),
    [Types.SIGN_UP_FAILED]: (state, { errorMessage }) => ({ ...state, loadingSignUp: false, signUpFailedErrorMessage: errorMessage }),

    [Types.CONFIRM_SIGN_UP]: state => ({
        ...state,
        loadingConfirmSignUp: true,
        confirmSignUpErrorMessage: null,
    }),
    [Types.CONFIRM_SIGN_UP_SUCCESS]: state => ({
        ...state,
        loadingConfirmSignUp: false,
    }),
    [Types.CONFIRM_SIGN_UP_FAILED]: (state, { errorMessage }) => ({
        ...state,
        loadingConfirmSignUp: false,
        confirmSignUpErrorMessage: errorMessage,
    }),

    [Types.RESEND_CODE]: state => ({ ...state, loadingResendCode: true }),
    [Types.RESEND_CODE_SUCCESS]: state => ({ ...state, loadingResendCode: false, resendCodeSucceeded: state.resendCodeSucceeded + 1 }),
    [Types.RESEND_CODE_FAILURE]: state => ({ ...state, loadingResendCode: false, resendCodeFailed: state.resendCodeFailed + 1 }),
})

export default Creators
